// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202604171333/js/" + chunkId + "." + {"44":"fae6985d","225":"924c7f47","481":"0403c561","486":"fd490bf0","770":"b20c76f3"}[chunkId] + ".0.31601899199382366.chunk.js";
};